import { Dispatch, SetStateAction, useCallback } from 'react';

type UseAttachmentsSharePanelArgs = {
    sharePanelOpen: boolean;
    setSharePanelOpen: Dispatch<SetStateAction<boolean>>;
    openShareForAttachmentId: string | null;
    setOpenShareForAttachmentId: Dispatch<SetStateAction<string | null>>;
};

export function useAttachmentsSharePanel({
    sharePanelOpen,
    setSharePanelOpen,
    openShareForAttachmentId,
    setOpenShareForAttachmentId
}: UseAttachmentsSharePanelArgs) {
    const openShareForExistingAttachment = useCallback(
        (attachmentId: string | null) => {
            setOpenShareForAttachmentId(attachmentId);
            setSharePanelOpen(Boolean(attachmentId));
        },
        [setOpenShareForAttachmentId, setSharePanelOpen]
    );

    const closeSharePanel = useCallback(() => {
        setSharePanelOpen(false);
        setOpenShareForAttachmentId(null);
    }, [setOpenShareForAttachmentId, setSharePanelOpen]);

    return {
        sharePanelOpen,
        openShareForAttachmentId,
        openShareForExistingAttachment,
        closeSharePanel
    };
}
